import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const BrandPage = lazy(() => import('../views/list/BrandPage'));

export function BrandPageLazy() {
	return (
		<PageSuspense>
			<BrandPage />
		</PageSuspense>
	);
}
